import { useMemo, useState } from "react";

/** 一页大约多少字。正文是纯文本，按字符估就够了。 */
const PAGE_CHARS = 1400;

/**
 * 按字符切页，尽量切在换行处。
 *
 * spec §5.4.2 的 AC 要求「长正文分页或虚拟滚动，不一次性渲染全部」。这一层
 * 只做**渲染**的分页 —— 正文仍然一次取回（`body` 本来就是整段），但 DOM 里
 * 只保留当前页，长文不会一次渲染十万字符。
 *
 * 优先在 `size` 之前的最后一个换行处切；整段没有换行时硬切，避免一页撑爆。
 */
export function paginate(text: string, size: number): string[] {
  const pages: string[] = [];
  let rest = text;
  while (rest.length > size) {
    const cut = rest.lastIndexOf("\n", size);
    if (cut <= 0) {
      pages.push(rest.slice(0, size));
      rest = rest.slice(size);
    } else {
      pages.push(rest.slice(0, cut));
      rest = rest.slice(cut + 1);
    }
  }
  pages.push(rest);
  return pages;
}

export function LongBody({ text }: { text: string }) {
  const pages = useMemo(() => paginate(text, PAGE_CHARS), [text]);
  const [page, setPage] = useState(0);

  if (pages.length <= 1) {
    return <div className="detail-body">{text}</div>;
  }

  const safePage = Math.min(page, pages.length - 1);

  return (
    <>
      <div className="detail-body">{pages[safePage]}</div>
      <div className="row-between">
        <button
          type="button"
          className="btn btn-ghost btn-sm"
          disabled={safePage === 0}
          onClick={() => setPage((p) => Math.max(p - 1, 0))}
        >
          上一页
        </button>
        <span className="small ghost-text mono">
          {safePage + 1} / {pages.length}
        </span>
        <button
          type="button"
          className="btn btn-ghost btn-sm"
          disabled={safePage >= pages.length - 1}
          onClick={() => setPage((p) => Math.min(p + 1, pages.length - 1))}
        >
          下一页
        </button>
      </div>
    </>
  );
}
